module.exports = __webpack_public_path__ + "static/media/logo.a0cd553d.png";